module.exports = __webpack_public_path__ + "static/media/thumbnail.0541d8d2.jpg";